
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/streamed-music",
      function () {
        return require("private-next-pages/streamed-music.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/streamed-music"])
      });
    }
  